import withUserGroupMembership from './withUserGroupMembership';

/**
 * determines if the current user is BOH employee
 * @returns {function(*): function(*=, *): *}
 */
export const withUserGroupMembershipBOH = () => {
  return withUserGroupMembership({
    isBackOfHouseUser: 'back_of_house',
  });
};

export default withUserGroupMembershipBOH;
